import { render, staticRenderFns } from "./sidebarItem.vue?vue&type=template&id=cd94e690"
import script from "./sidebarItem.vue?vue&type=script&lang=js"
export * from "./sidebarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd94e690')) {
      api.createRecord('cd94e690', component.options)
    } else {
      api.reload('cd94e690', component.options)
    }
    module.hot.accept("./sidebarItem.vue?vue&type=template&id=cd94e690", function () {
      api.rerender('cd94e690', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/index/sidebar/sidebarItem.vue"
export default component.exports